import { render, staticRenderFns } from "./laporan_perubahan_data_op.vue?vue&type=template&id=eb55970e&"
import script from "./laporan_perubahan_data_op.vue?vue&type=script&lang=js&"
export * from "./laporan_perubahan_data_op.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports